// @unocss-include

import { cn } from '@/utils/classname';

export const fill = (isActive: boolean) =>
  cn(
    'transition-colors group-active:fill-primary-200 group-active:stroke-primary-400 group-hover:group-active:fill-primary-200 group-hover:group-active:stroke-primary-400',
    isActive
      ? 'fill-primary-200 stroke-primary-400'
      : 'stroke-neutral-600 group-hover:fill-neutral-300',
  );

export const stroke = (isActive: boolean) =>
  cn(
    'transition-colors group-active:stroke-primary-400 group-hover:group-active:stroke-primary-400',
    isActive ? 'stroke-primary-400' : 'stroke-neutral-600',
  );

export const fakeStroke = (isActive: boolean) =>
  cn(
    'transition-colors group-active:fill-primary-400 group-hover:group-active:fill-primary-400',
    isActive ? 'fill-primary-400' : 'fill-neutral-600',
  );
